<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-0">
    <component is="style">

      .print-container{
      font-family: {{font}};
      }

      .title{
      font-size: {{titleSize}}px;
      text-align:center;
      margin-bottom:{{margin}};
      }

      .description{
      margin-top:{{margin}};
      font-size: {{descriptionSize}}px;
      }

      .image{
      text-align:center;
      }

      .qrcode td{
      padding: {{margin}};
      }

      .qrcode{
      border-right:2px dashed #ccc;
      border-bottom:2px dashed #ccc;

      {{dynamicCSS}}
      }

      .qrCode-container{
      height:{{height}} !important;
      width:{{width}} !important;
      }

      .qrCode-container{
      
      }

      .qrCode-container-default{

      }

      .qrCode-container-rotated .qrcode{
      transform: rotate(-90deg) !important;
      transform-origin: {{halfWidth}} {{halfWidth}};
      }

      .qrCode-container-vertical .qrcode{
      background-color:{{backgroundColor}};
      position:relative !important;
      }

      @media print {
      body{
      -webkit-print-color-adjust: exact !important;   /* Chrome, Safari, Edge */
      color-adjust: exact !important;                 /*Firefox*/
      }
      .container-fluid, .row{
      padding:0;
      margin:0;
      }

      .print-hide {
      display: none;
      }

      #settings {
      display: none;
      }

      .qrcode{
      border:none;
      background-color:{{backgroundColor}} !important;
      -webkit-print-color-adjust: exact;
      }

      .arrow-container {
      display: none;
      }

      #testSize{
      display:none;
      }
      }

    </component>

    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-md-4 pl-4">
          <div class="row print-hide">
            <div class="col-12 custom-form-label px-0">
              <h1 class="m-0">Print your QR code</h1>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12 px-0">
              <table cellpadding="0" cellspacing="0">
                <tr>
                  <td height="100%" style="position:relative; width:20px;height:100%">
                    <table height="100%" cellpadding="0" cellspacing="0" border="0" class="arrow-container" style="margin:0px;padding:0px;width:20px">
                      <tr>
                        <td align="center" height="10" class="p-0 m-0" style="line-height:10px; height:10px;">
                          <i class="icon-arrow-up5" style="top:0px;bottom:0px;line-height:20px;font-size:20px;margin-bottom:-5px;"></i>
                        </td>
                      </tr>
                      <tr>
                        <td height="100%" align="center" class="p-0 m-0" style="">
                          <span style="background-color:black;display:inline-table;width:1px;height:100%;"></span>
                          <div style="position:absolute;top:50%;margin-left:-40px">{{height}}</div>
                        </td>
                      </tr>
                      <tr>
                        <td align="center" height="10" class="p-0 m-0" style="line-height:10px; height:10px;">
                          <i class="icon-arrow-down5" style="top: 0px; bottom: 0px; line-height: 20px; font-size: 20px; margin-top: -10px;"></i>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td height="100%" style="position: relative;height: 100%;background-color: pink" class="print-container">
                    <div class="qrCode-container" v-bind:class="{'qrCode-container-vertical' : direction == 'default' , 'qrCode-container-rotated' : direction == 'rotated'}" v-bind:id="'qrContainer' + getId()" style="position:relative;margin:0;top:0px; left:0px;">
                      <table class="qrcode" v-bind:style="getQRStyle()">
                        <tr>
                          <td class="" v-html="qrcontent" contenteditable="true">
                          </td>
                        </tr>
                      </table>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style="height:20px" colspan="2" height="20">
                    <table height="20" width="100%" cellpadding="0" cellspacing="0" class="arrow-container" style="margin:0px;padding:0px;width:100%;height:20px" border="0">
                      <tr>
                        <td valign="middle" width="10" height="20" class="p-0 m-0" style=" line-height: 20px;">
                          <i class="icon-arrow-left5" style="font-size:20px;line-height:20px;"></i>
                        </td>
                        <td valign="middle" width="100%" height="20" class="p-0 m-0" style=" line-height: 0px; position:relative;">
                          <span style="background-color:black;display:inline-table;width:100%;height:1px;line-height:1px;margin-bottom:5px;margin-left:-5px;"></span>
                          <div style="position:absolute;left:calc(-20px + 50%);margin-top:20px">{{width}}</div>
                        </td>
                        <td valign="middle" width="10" height="20" class="p-0 m-0" style=" line-height: 20px;">
                          <i class="icon-arrow-right5" style="font-size: 20px; line-height: 20px;margin-left:-10px;"></i>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-3" id="settings">
          <div class="container-fluid">
            <div class="row">
              <div class="col-12 px-0">
                <h1 class="m-0">Settings</h1>
              </div>
            </div>
            <div class="row mt-3 text-center">
              <div class="col text-center">
                <a style="color:inherit" @click="doPrint" class="btn btn-link skin btn-primary">{{$t('print')}}</a>
              </div>

            </div>
            <div class="row mt-3">
              <div class="col-12 custom-form-label px-0">
                {{$t('direction')}}
              </div>
            </div>
            <div class="row mt-1">
              <div class="col px-0">
                <select class="form-control" v-model="direction" @change="directionChanged">
                  <option value="default">Portrait</option>
                  <option value="landscape">Landscape</option>
                  <option value="rotated">Rotate</option>
                </select>
              </div>
            </div>

            
            

            <div class="row mt-3">
              <div class="col px-0">
                <container-expand-right class="mt-2 px-0" v-bind:show="true" v-bind:title="'Looks and appearance'">
                  <div class="container-fluid">
                    <div class="row mt-3">
                      <div class="col-12 custom-form-label px-0">
                        {{$t('font')}}
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col px-0">
                        <select class="form-control" v-model="font">
                          <option value="arial">Arial</option>
                          <option value="verdana">Verdana</option>
                        </select>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-12 custom-form-label px-0">
                        {{$t('title_size')}}
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col-12 px-0">
                        <select class="form-control" v-model="titleSize">
                          <option value="8">8</option>
                          <option value="10">10</option>
                          <option value="12">12</option>
                          <option value="14">12</option>
                          <option value="16">16</option>
                          <option value="20">20</option>
                        </select>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-12 custom-form-label px-0">
                        {{$t('description_size')}}
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col-12 px-0">
                        <select class="form-control" v-model="descriptionSize">
                          <option value="16">16</option>
                          <option value="18">18</option>
                          <option value="20">20</option>
                          <option value="22">22</option>
                          <option value="24">24</option>
                          <option value="26">26</option>
                        </select>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-12 custom-form-label px-0">
                        {{$t('margin')}}
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col-12 px-0">
                        <select class="form-control" v-model="margin">
                          <option value="0mm">0mm</option>
                          <option value="2mm">2mm</option>
                          <option value="4mm">4mm</option>
                          <option value="6mm">6mm</option>
                          <option value="8mm">8mm</option>
                          <option value="10mm">10mm</option>
                        </select>
                      </div>
                    </div>

                    <div class="row mt-3">
                      <div class="col px-0">
                        Background color
                      </div>
                    </div>
                    <div class="row mt-1 mb-3">
                      <div class="col px-0">
                        <input-color-selector @changed="doBgColorChange"></input-color-selector>
                      </div>
                    </div>

                  </div>


                </container-expand-right>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col px-0">
                <container-expand-right class="mt-2 px-0" v-bind:show="true" v-bind:title="'Printer presets'">
                  <div class="container-fluid">
                    <div class="row mt-3">
                      <div class="col-12 custom-form-label px-0">
                        {{$t('printers')}}
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col-12 px-0">
                        <select class="form-control" v-model="selectedPrinter" @change="changePrinter">
                          <option value="">Select printer</option>
                          <option v-for="p in qrDevices" v-bind:value="p.name">{{p.name}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-12 custom-form-label px-0">
                        {{$t('dimension_preset')}}
                      </div>
                    </div>
                    <div class="row mt-1 mb-3">
                      <div class="col-12 px-0">
                        <select class="form-control" v-model="selectedDimension" @change="changeDimensions">
                          <option disabled value="">Select dimensions</option>
                          <option v-for="p in qrDimensions" v-bind:value="p.name">{{p.name}}</option>
                        </select>
                      </div>
                    </div>

                  </div>


                </container-expand-right>
              </div>
            </div>






          </div>
      </div>
  </div>


  </div>

  

  <div id="testSize" style="width:1in;height:1in;"></div>
  </div>
</template>

<script>
 
  let message = "";

  export default {
    name: "qrcode-advanced-print",
    components: {

    },
    props: {
      qrcodeId: {
        type: Number,
        default: 36
      },
      title: {
        type: String,
        default: "Enter title"
      },
      description: {
        type: String,
        default: "Enter description"
      },
    },
    data() {
      return {
        message: "",
        name: "",
        enabled: "",
        longitude: 0,
        lattitude: 0,
        height: 0,
        halfHeight:0,
        width: 0,
        halfWidth:0,
        resolution: 96,
        descriptionSize: 16,
        titleSize: 8,
        font: 'verdana',
        direction: 'default',
        image: '',
        qrDevices: [],
        qrDimensions: [],
        dynamicCSS: '',
        qrcontent: '',
        margin: '2mm',
        backgroundColor: '#fff'
      };
    },
    methods: {
      getQRStyle() {
        var style = "background-color:" + this.backgroundColor;
        return style;
      },
      doBgColorChange(colorStr) {
        this.backgroundColor = colorStr;
      },
      doPrint() {
        this.$forceUpdate();
        print();
      },
      applyTemplate(selectectedTemplate) {
        var title = this.title;
        if (title == "") {
          title = "The title"
        }
        var description = this.description;
        if (description == "") {
          description = "Some example description, tell your users more.. Sometimes this text could even be three rows"
        }

        var css = selectectedTemplate.style;
        css += "max-width" + selectectedTemplate.x + ";\n";
        css += "max-height" + selectectedTemplate.y + ";\n";

        // Rotation or not
        if (this.direction == "rotated") {
          /*
          css += "-ms-transform:rotate(-90deg);\n";
          css += "-ms-transform:rotate(-90deg);\n";
          css += "-webkit-transform: rotate(-90deg);\n"
          css += "-o-transform:rotate(-90deg);\n";
          css += "transform: rotate(-90deg);\n";
          */
        }

        this.dynamicCSS = css;

        var template = selectectedTemplate.html;
        template = template.replace("{{title}}", title);
        template = template.replace("{{image}}", '<img width="100%" src="' + this.qrsource + '" />');
        template = template.replace("{{description}}", description)

        this.qrcontent = template;

       /* var thisContext = this;
        setTimeout(function () {
          $(".title,.image,.description").resizable({
            handles: "all",
            resize: thisContext.resizeFix
          });
          */
          /*
          alert("setting resizable")
          $(".item").each(function () {
            $(this).hover(function () {
              $(this).resizable();
            }, function () {
              $(this).resizable("destroy");
            });
          });
        }, 500)*/
      },

      directionChanged() {

        var containerName = '.qrcode';
        var tmpHeight = parseFloat($(containerName).height());
        var tmpWidth = parseFloat($(containerName).width());

        if (this.direction == "rotated") {
          $(containerName).resizable('destroy');
          this.width = tmpHeight;
          this.height = tmpWidth;
          
        }
        else {
          $(containerName).resizable({
            handles: "all",
            resize: this.resizeFix
          });
          this.width = tmpWidth;
          this.height = tmpHeight;
        }

        this.adjustSizes();
        //var thisContext = this;
        //setTimeout(function () {
        //  thisContext.calculateSizes();
        //}, 500)
      },

      adjustSizes() {
        var containerName = '#qrContainer' + this.getId();
        $(containerName).width(this.width);
        $(containerName).height(this.height);
      },
      calculateSizes() {

        //var containerName = '#qrContainer' + this.getId();

        var containerName = '.qrcode';

        var width = $(containerName).width()
        width = this.getSizeInMM(width);

        var height = $(containerName).height()
        height = this.getSizeInMM(height);

        this.width = width + "mm";
        this.height = height + "mm";
        this.halfWidth = $(containerName).width() / 2 + "px";
        this.halfHeight = $(containerName).height() / 2 + "px";

        // Set the container width
        //$('#qrContainer' + this.getId()).height(parseFloat(this.height));
        //$('#qrContainer' + this.getId()).width(parseFloat(this.width));

      },
      getResolution() {
        var test = document.getElementById("testSize")
        var testSize = test.getBoundingClientRect();
        this.resolution = testSize.width;
      },
      getSizeInMM(sizeInPX) {
        var size = sizeInPX * 2.54 * 10 / (this.resolution)
        return Math.round(size)
      },
      resizeFix(event, ui) {

      },
      getId() {
        return this._uid;
      },
      async getQRCode(qrcodeId) {
        try {         
          this.$http.get('/api/QRCodes/v1/' + qrcodeId).then(async response => {
            var qrcode = response.data;
            this.name = qrcode.Name;
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      changeDimensions() {
        var sel = this.getSelectedDimension();
        if (sel == null) {
          this.width = '200mm';
          this.height = '300mm';
          this.direction = 'default';
        }
        else {
          this.width = sel.x;
          this.height = sel.y;
          if (sel.isrotated == true)
            this.direction = 'rotated';
          else
            this.direction = 'default';
          this.applyTemplate(sel);
        }

        this.$forceUpdate();
      },
      changePrinter() {
        this.selectedDimension = '';
        this.qrDimensions = this.loadDimensions(this.selectedPrinter);
      },
      getSelectedDimension() {
        if (this.selectedDimension == "")
          return null;
        var selectedDimension = null;
        var dimensions = this.loadDimensions(this.selectedPrinter);
        for (var i = 0; i < dimensions.length; i++) {
          if (this.selectedDimension == dimensions[i].name)
            selectedDimension = dimensions[i];
        }
        return selectedDimension;
      },
      loadDevices() {
        return [{ name: "Standard" }, { name: "Dymo" }]
      },
      loadDimensions(printer) {
        var data = [
          { printer: "Standard", name: "Standard 1 270px X 450px", x: "270px", y: "450px", isrotated: false, html: '<div class="title item" contenteditable="true">{{title}}</div><div class="image item">{{image}}</div><div class="description item" contenteditable="true">{{description}}</div>', style: '.title{font-size:30px;padding-top:20px;text-align:center} .description{font-size:20px; padding-left:15px; padding-right:15px;} .image{position:relative;text-align:center} .image img{width:260px;} .printercontainer{width:270px; height:500px}' },
          { printer: "Dymo", name: "Dymo 89x25", x: "89mm", y: "25mm", isrotated: false, html: '<div><div class="title item" contenteditable="true">{{title}}</div><div class="description item" contenteditable="true">{{description}}</div></div><div class="image item">{{image}}</div>', style: '.title{position:absolute;top:10;left:10px;px;font-size:20px;} .description{position:absolute;top:38px;left:10px;font-size:12px;width: 225px} .image{position:absolute;top:0px;right:0px;} .image img{width:25mm;} .printercontainer{}' },
          { printer: "Dymo", name: "Dymo 54x25", x: "54mm", y: "25mm", isrotated: false, html: '<div><div class="title item" contenteditable="true">{{title}}</div><div class="description item" contenteditable="true">{{description}}</div></div><div class="image item">{{image}}</div>', style: '.title{position:absolute;top:10;left:10px;px;font-size:16px;} .description{position:absolute;top:38px;left:10px;font-size:12px;width: 100px} .image{position:absolute;top:0px;right:0px;} .image img{width:25mm;} .printercontainer{}' },
          { printer: "Dymo", name: "Dymo 54x25 rotated", x: "25mm", y: "54mm", isrotated: true, html: '<div><div class="title item" contenteditable="true">{{title}}</div><div class="description item" contenteditable="true">{{description}}</div></div><div class="image item">{{image}}</div>', style: '.title{position:absolute;top:10;left:7px;px;font-size:17px;} .description{position:absolute;top:34px;left:7px;font-size:11px;width: 83px} .image{position:absolute;bottom:0px;right:0px;} .image img{width:25mm;} .printercontainer{margin-top:-55px; margin-left:56px}' },
        ]
        //margin-left: 108px;margin-top: -123px;
        var ret = [];
        for (var i = 0; i < data.length; i++) {
          if (printer == data[i].printer)
            ret.push(data[i]);
        }
        return ret;
      },
    },
    watch: {
      qrcodeId: function (newVal, oldVal) {
        if (newVal > 0) {
          this.getQRCode(newVal);
        }
      },
    },
    mounted() {
      if (this.qrcodeId > 0) {
        this.getQRCode(this.qrcodeId);
      }

      this.qrDevices = this.loadDevices();

      this.applyTemplate(this.loadDimensions("Standard")[0])

      this.getResolution();

      this.calculateSizes();
      
      //var containerName = '#qrContainer' + this.getId() ;
      var containerName = '.qrcode';
      
      var thisContext = this;

      $(containerName).resize(function () {
        thisContext.calculateSizes();
      });

      setTimeout(function () {
        $(containerName).resizable({
          handles: "all",
          resize: thisContext.resizeFix
        });
      }, 100)
    },
    computed: {
      realValue() {
        "color:green;"
      },
      qrsource: {
        get: function () {
          return apiUrl + '/api/Procedures/v1/GetQRCodeById?qrcodeid=' + this.qrcodeId + '&siteId=' + this.$store.getSiteId();
        },
      }

    },
  };
</script>
<style scoped>

  .arrow-container {
    
  }




</style>




// WEBPACK FOOTER //
// src/components/qrcode/qrcode-advanced-print.vue